import {
  isZeroSumBalanced,
  leagueMean,
  leagueSum,
  PS_LEAGUE_SUM_TOLERANCE,
} from '../../utils/psRatingZeroSum'
import { signed } from '../../utils/psRatingFormat'

export function PsRatingLeagueBalance({
  ratings,
  serverOk,
}: {
  ratings: Record<string, number>
  /** When API includes balance.ok, show agreement with server check. */
  serverOk?: boolean
}) {
  const sum = leagueSum(ratings)
  const mean = leagueMean(ratings)
  const ok = isZeroSumBalanced(ratings)
  const teamCount = Object.keys(ratings).length

  return (
    <div
      className={[
        'rounded-lg border px-4 py-3 text-sm',
        ok ? 'border-emerald-200 bg-emerald-50 text-emerald-950' : 'border-amber-200 bg-amber-50 text-amber-950',
      ].join(' ')}
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="font-medium">
          League balance{' '}
          {ok ? (
            <span className="text-emerald-700">within ±{PS_LEAGUE_SUM_TOLERANCE}</span>
          ) : (
            <span className="text-amber-800">needs attention</span>
          )}
        </p>
        {serverOk != null && (
          <span className="text-xs text-slate-600">
            Saved data: {serverOk ? 'balanced' : 'check audit replay'}
          </span>
        )}
      </div>
      <dl className="mt-2 grid gap-1 font-mono text-xs sm:grid-cols-3">
        <div>
          <dt className="text-slate-600">Sum of ratings</dt>
          <dd className="font-semibold tabular-nums">{signed(sum)}</dd>
        </div>
        <div>
          <dt className="text-slate-600">League mean</dt>
          <dd className="font-semibold tabular-nums">{signed(mean)}</dd>
        </div>
        <div>
          <dt className="text-slate-600">Target</dt>
          <dd className="font-semibold tabular-nums">0.000 ({teamCount} teams)</dd>
        </div>
      </dl>
      <p className="mt-2 text-xs leading-relaxed text-slate-600">
        MLB PS ratings are <strong>mean-zero</strong> (total should be ~0, not 100%). Share tables like
        World Cup strength % sum to 100% on a different scale.
      </p>
    </div>
  )
}
